"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const insuranceCertificatePurchaseResponse_1 = __importDefault(require("../insuranceCertificatePurchaseResponse"));
class InsuranceCertificatePurchaseSummary extends insuranceCertificatePurchaseResponse_1.default {
    constructor(certificateNumber, productId, productName, currency, limit, deductible, premium, serviceFee, tax, certificateLink, termsAndConditionsLink, fileClaimLink, certificateWithCoverPageLink, otherFiles, status) {
        super(certificateNumber, productId, productName, currency, limit, deductible, premium, serviceFee, tax);
        this.certificateLink = certificateLink;
        this.termsAndConditionsLink = termsAndConditionsLink;
        this.fileClaimLink = fileClaimLink;
        this.certificateWithCoverPageLink = certificateWithCoverPageLink;
        this.otherFiles = otherFiles;
        this.status = status;
    }
    static create(certificate, certificateLink, termsAndConditionsLink, fileClaimLink, certificateWithCoverPageLink, otherFiles) {
        const { certificateNumber, coverage: { id: productId, name: productName, currency, limit, deductible, premium, serviceFee, tax }, status } = certificate;
        return new InsuranceCertificatePurchaseSummary(certificateNumber, productId, productName, currency, limit, deductible, premium, serviceFee, tax, certificateLink, termsAndConditionsLink, fileClaimLink, certificateWithCoverPageLink, otherFiles, status);
    }
}
exports.default = InsuranceCertificatePurchaseSummary;
//# sourceMappingURL=insuranceCertificatePurchaseSummary.class.js.map